import {itemsOnPage} from "../assets/const";
import {createNotification} from "../components/Notifications/Notifications";
import {api} from "../App";
import {
    SET_ADS,
    SET_ADS_LOADING,
    SET_ADS_BY_ID,
    SET_EVENT_TYPES,
    SET_EVENT_TYPES_LOADING,
    SET_EVENT_TYPE_BY_ID,
    SET_ADS_BY_ID_LOADING
} from "./types";

export const getAds = (from, to) => async(dispatch, getState) => {
    dispatch({type: SET_ADS_LOADING, payload: true});
    try {
        const {data} = await api.get(`/posts?from_date=${from}&to_date=${to} 23:59:59`);
        dispatch({type: SET_ADS, payload: data});
    } catch (error) {
        createNotification('error', 'Ошибка');
    } finally {
        dispatch({type: SET_ADS_LOADING, payload: false});
    }
};

export const getAdsById = (id) => async(dispatch, getState) => {
    dispatch({type: SET_ADS_BY_ID_LOADING, payload: true});
    try {
        const {data} = await api.get(`/posts/${id}`);
        dispatch({type: SET_ADS_BY_ID, payload: data});
    } catch (error) {
        createNotification('error', 'Ошибка');
    } finally {
        dispatch({type: SET_ADS_BY_ID_LOADING, payload: false});
    }
};

export const createAds = (data, from, to) => async(dispatch, getState) => {
    try {
        await api.post(`/posts`, data);
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', 'Ошибка');
    } finally {
        await dispatch(getAds(from, to));
    }
};

export const editAds = (data, from, to) => async(dispatch, getState) => {
    try {
        await api.put(`/posts/${data.postid}`, data);
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', 'Ошибка');
    } finally {
        await dispatch(getAds(from, to));
    }
};

export const deleteAds = (id, from, to) => async(dispatch, getState) => {
    try {
        await api.delete(`/posts/${id}`);
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', 'Ошибка');
    } finally {
        await dispatch(getAds(from, to));
    }
};

export const getEventTypes = () => async(dispatch, getState) => {
    dispatch({type: SET_EVENT_TYPES_LOADING, payload: true});
    try {
        const {data} = await api.get(`/event_types`);
        dispatch({type: SET_EVENT_TYPES, payload: data});
    } catch (error) {
        createNotification('error', 'Ошибка');
    } finally {
        dispatch({type: SET_EVENT_TYPES_LOADING, payload: false});
    }
};

export const deleteEventType = (id) => async(dispatch, getState) => {
    try {
        await api.delete(`/event_types/${id}`);
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', 'Ошибка');
    } finally {
        await dispatch(getEventTypes());
    }
};

export const getEventTypeById = (id) => async(dispatch, getState) => {
    try {
        const {data} = await api.get(`/event_types/${id}`);
        dispatch({type: SET_EVENT_TYPE_BY_ID, payload: data});
    } catch (error) {
        createNotification('error', 'Ошибка');
    }
};

export const editEventType = (data) => async(dispatch, getState) => {
    let success
    try {
        await api.put(`/event_types/${data.ev_type_id}`, data);
        success = true
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', 'Ошибка');
    } finally {
        await dispatch(getEventTypes());
        return success
    }
};

export const createEventType = (data) => async(dispatch, getState) => {
    let success
    try {
        await api.post(`/event_types`, data);
        success = true
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', 'Ошибка');
    } finally {
        await dispatch(getEventTypes());
        return success
    }
};